import { useState } from "react";
import toast from "react-hot-toast";

// const useValidation = () => {

//     const [validationStates, setValidationStates] = useState({});

//     const validateInput = (inputId, regex, emptyMessage = "Value required!", invalidMessage = "Please enter a valid value.") => {
//         const value = document.getElementById(inputId).value;
//         const isValidInput = regex.test(value);
//         const inputElement = document.getElementById(inputId);
        
//         let labelElement = inputElement.previousElementSibling;
//         while (labelElement && labelElement.tagName.toLowerCase() !== 'label') {
//             labelElement = labelElement.previousElementSibling;
//         }
        
//         // console.log(`Validating ${inputId}: ${value}, Valid: ${isValidInput}`);

//         setValidationStates((prevStates) => {
//             const newState = {
//                 ...prevStates,
//                 [inputId]: isValidInput,
//             };
//             // console.log('Updated Validation States:', newState);
//             return newState;
//         });

//         if (!value) {
//             toast.error(labelElement.textContent + " cannot be empty" || emptyMessage);
//             setValidationStates((prevStates) => ({
//                 ...prevStates,
//                 [inputId]: false,
//             }));
//         } else if (value && !isValidInput) {
//             toast.error(labelElement.textContent + " is invalid" || invalidMessage);
//             setValidationStates((prevStates) => ({
//                 ...prevStates,
//                 [inputId]: false,
//             }));
//         }

//         return isValidInput;
//     };

//     return { validateInput, validationStates, setValidationStates };
// };
const useValidation = () => {
    const [validationStates, setValidationStates] = useState({});

    const validateInput = (inputId, regex, emptyMessage = "Value required!", invalidMessage = "Please enter a valid value.") => {
        const value = document.getElementById(inputId).value;
        const isValidInput = regex.test(value);
        const inputElement = document.getElementById(inputId);
        
        let labelElement = inputElement.previousElementSibling;
        while (labelElement && labelElement.tagName.toLowerCase() !== 'label') {
            labelElement = labelElement.previousElementSibling;
        }

        const currentDate = new Date().toISOString().split('T')[0];
        const isDateInvalid = (inputId === 'date' || inputId === 'portDate') && value <= currentDate;

        setValidationStates((prevStates) => {
            const newState = {
                ...prevStates,
                [inputId]: isValidInput && !isDateInvalid,
            };
            return newState;
        });

        if (!value) {
            toast.error(labelElement.textContent + " cannot be empty" || emptyMessage);
            setValidationStates((prevStates) => ({
                ...prevStates,
                [inputId]: false,
            }));
        } else if (isDateInvalid) {
            toast.error(labelElement.textContent + " cannot be in the past or today" || invalidMessage);
            setValidationStates((prevStates) => ({
                ...prevStates,
                [inputId]: false,
            }));
        } else if (value && !isValidInput) {
            toast.error(labelElement.textContent + " is invalid" || invalidMessage);
            setValidationStates((prevStates) => ({
                ...prevStates,
                [inputId]: false,
            }));
        }

        return isValidInput && !isDateInvalid;
    };

    return { validateInput, validationStates, setValidationStates };
};


export default useValidation;